import { HashRouter } from 'react-router-dom';
import App from './App';
import React from 'react';

const Root = () => (
    <HashRouter >
      <App/>
    </HashRouter>
);

export default Root;



// WEBPACK FOOTER //
// ./src/root.jsx